import React from "react";
import { FC } from "react";
import { useState } from "react";
import { useCallback } from "react";
import Error from "../../../../components/Error";
import Grid from "@material-ui/core/Grid";
import { Form } from "react-final-form";
import FilterForm from "./FilterForm";
import UserListItem from "../admin/UserListItem";

interface SchoolUsersListProps {
  schoolUsers: Array<any>;
  refetch: Function;
}

const SchoolUsersList: FC<SchoolUsersListProps> = ({
  schoolUsers,
  refetch,
}) => {
  const [results, setResults] = useState(schoolUsers);

  const handleSubmit = useCallback(
    ({ schoolType, keyword }) => {
      let res = schoolUsers;

      if (schoolType) {
        res = res.filter(
          (user) => user.schoolProfile?.school?.typeId === schoolType.id,
        );
      }
      if (keyword) {
        res = res.filter((user) =>
          (user.name + user.email + user.schoolProfile?.school?.name)
            .toLowerCase()
            .includes(keyword.toLowerCase()),
        );
      }
      setResults(res);
    },
    [schoolUsers],
  );

  return (
    <>
      <Form onSubmit={handleSubmit} component={FilterForm} />
      <Grid container spacing={2}>
        {results.length ? (
          results.map((schoolUser) => (
            <UserListItem
              key={`SchoolGridItem_${schoolUser.id}`}
              user={schoolUser}
              refetch={refetch}
            />
          ))
        ) : (
          <Error text={"No school user found"} />
        )}
      </Grid>
    </>
  );
};

export default React.memo(SchoolUsersList);
